export const reelsData = [
    {
        "id": 1,
        "title": "ABBA (Edición) ",
        "category": "general",
        "videoSrc": "/assets/videos/ABBA (Edición) .mp4",
        "poster": "/assets/videos/ABBA (Edición) .webp",
        "column": 0,
        "mentions": [
            {
                "name": "André Coronel",
                "occupation": "Director & Editor",
                "link": "https://instagram.com/andrecoronel"
            }
        ]
    },
    {
        "id": 2,
        "title": "Alex Anwandter (Edición y guion propio)",
        "category": "general",
        "videoSrc": "/assets/videos/Alex Anwandter (Edición y guion propio).mp4",
        "poster": "/assets/videos/Alex Anwandter (Edición y guion propio).webp",
        "column": 1,
        "mentions": [
            {
                "name": "André Coronel",
                "occupation": "Creative Direction",
                "link": ""
            }
        ]
    },
    {
        "id": 3,
        "title": "Arca - Artista emergente (Edición)",
        "category": "general",
        "videoSrc": "/assets/videos/Arca - Artista emergente (Edición).mp4",
        "poster": "",
        "column": 2
    },
    {
        "id": 4,
        "title": "Axsion productora - Reel de posicionamiento 1 (edición y concepto)",
        "category": "general",
        "videoSrc": "/assets/videos/Axsion productora - Reel de posicionamiento 1 (edición y concepto).mp4",
        "poster": "/assets/videos/Axsion productora - Reel de posicionamiento 1 (edición y concepto).webp",
        "column": 3
    },
    {
        "id": 5,
        "title": "Axsion productora - Reel de posicionamiento 2 (edición y concepto)",
        "category": "general",
        "videoSrc": "/assets/videos/Axsion productora - Reel de posicionamiento 2 (edición y concepto).mp4",
        "poster": "/assets/videos/Axsion productora - Reel de posicionamiento 2 (edición y concepto).webp",
        "column": 0
    },
    {
        "id": 6,
        "title": "Axsion productora - Reel de posicionamiento 3 (edición y concepto)",
        "category": "general",
        "videoSrc": "/assets/videos/Axsion productora - Reel de posicionamiento 3 (edición y concepto).mp4",
        "poster": "/assets/videos/Axsion productora - Reel de posicionamiento 3 (edición y concepto).webp",
        "column": 1
    },
    {
        "id": 7,
        "title": "Axsion productora - Reel de viralidad (edición y concepto)",
        "category": "general",
        "videoSrc": "/assets/videos/Axsion productora - Reel de viralidad (edición y concepto).mp4",
        "poster": "/assets/videos/Axsion productora - Reel de viralidad (edición y concepto).webp",
        "column": 2
    },
    {
        "id": 8,
        "title": "Cigarettes After Sex - Reel de promoción (Registro y edicion) ",
        "category": "general",
        "videoSrc": "/assets/videos/Cigarettes After Sex - Reel de promoción (Registro y edicion) .mp4",
        "poster": "/assets/videos/Cigarettes After Sex - Reel de promoción (Registro y edicion) .webp",
        "column": 3,
        "mentions": [
            {
                "name": "Marina Garrone",
                "occupation": "Redactora Creativa",
                "link": "https://signodefueg0.com"
            }
        ]
    },
    {
        "id": 9,
        "title": "Clip de carrusel",
        "category": "general",
        "videoSrc": "/assets/videos/Clip de carrusel.mp4",
        "poster": "/assets/videos/Clip de carrusel.webp",
        "column": 0
    },
    {
        "id": 14,
        "title": "Cobertura de evento - Fiesta fin de año KronenVet",
        "category": "general",
        "videoSrc": "/assets/videos/Cobertura de evento - Fiesta fin de año KronenVet.mp4",
        "poster": "/assets/videos/Cobertura de evento - Fiesta fin de año KronenVet.webp",
        "column": 1
    },
    {
        "id": 10,
        "title": "Cobertura Móvil - Dia 1 Festi Capital (Filmmaker y edición)",
        "category": "general",
        "videoSrc": "/assets/videos/Cobertura Móvil - Dia 1 Festi Capital (Filmmaker y edición).webm",
        "poster": "/assets/videos/Cobertura Móvil - Dia 1 Festi Capital (Filmmaker y edición).webp",
        "column": 2
    },
    {
        "id": 11,
        "title": "Cobertura Ping Pong  - Shitstem artista independiente (registro y edición)",
        "category": "general",
        "videoSrc": "/assets/videos/Cobertura Ping Pong  - Shitstem artista independiente (registro y edición).webm",
        "poster": "/assets/videos/Cobertura Ping Pong  - Shitstem artista independiente (registro y edición).webp",
        "column": 3
    },
    {
        "id": 12,
        "title": "Cobertura Rayos Laser (Registro y edición)",
        "category": "general",
        "videoSrc": "/assets/videos/Cobertura Rayos Laser (Registro y edición).mp4",
        "poster": "/assets/videos/Cobertura Rayos Laser (Registro y edición).webp",
        "column": 0
    },
    {
        "id": 13,
        "title": "Cobertura Semana del indie",
        "category": "general",
        "videoSrc": "/assets/videos/Cobertura Semana del indie.webm",
        "poster": "/assets/videos/Cobertura Semana del indie.webp",
        "column": 1
    },
    {
        "id": 15,
        "title": "Contenido Drone Fedes Agency",
        "category": "general",
        "videoSrc": "/assets/videos/Contenido Drone Fedes Agency.webm",
        "poster": "/assets/videos/Contenido Drone Fedes Agency.webp",
        "column": 2
    },
    {
        "id": 16,
        "title": "Corrección de color y registro",
        "category": "general",
        "videoSrc": "/assets/videos/Corrección de color y registro.webm",
        "poster": "/assets/videos/Corrección de color y registro.webp",
        "column": 3
    },
    {
        "id": 17,
        "title": "Día mundial de la prevención del cáncer de mama(Edición y composición))",
        "category": "general",
        "videoSrc": "/assets/videos/Día mundial de la prevención del cáncer de mama(Edición y composición)).webm",
        "poster": "/assets/videos/Día mundial de la prevención del cáncer de mama(Edición y composición)).webp",
        "column": 0
    },
    {
        "id": 19,
        "title": "El hipódromo de La Plata (Fimmaking y edición)",
        "category": "general",
        "videoSrc": "/assets/videos/El hipódromo de La Plata (Fimmaking y edición).webm",
        "poster": "/assets/videos/El hipódromo de La Plata (Fimmaking y edición).webp",
        "column": 1
    },
    {
        "id": 18,
        "title": "ENTREVISTA Maca Sanchez (Edición y registro)",
        "category": "general",
        "videoSrc": "/assets/videos/ENTREVISTA Maca Sanchez (Edición y registro).webm",
        "poster": "/assets/videos/ENTREVISTA Maca Sanchez (Edición y registro).webp",
        "column": 2,
        "mentions": [
            {
                "name": "Marina Garrone",
                "occupation": "Publicista",
                "link": "https://signodefueg0.com"
            }
        ]
    },
    {
        "id": 20,
        "title": "Evento de electrónica (Registro y edición)",
        "category": "general",
        "videoSrc": "/assets/videos/Evento de electrónica (Registro y edición).webm",
        "poster": "/assets/videos/Evento de electrónica (Registro y edición).webp",
        "column": 3
    },
    {
        "id": 21,
        "title": "Eyedress - artista emergente (Edición y guion propio)",
        "category": "general",
        "videoSrc": "/assets/videos/Eyedress - artista emergente (Edición y guion propio).webm",
        "poster": "/assets/videos/Eyedress - artista emergente (Edición y guion propio).webp",
        "column": 0
    },
    {
        "id": 22,
        "title": "Federico García Lorca(Edición)",
        "category": "general",
        "videoSrc": "/assets/videos/Federico García Lorca(Edición).webm",
        "poster": "/assets/videos/Federico García Lorca(Edición).webp",
        "column": 1
    },
    {
        "id": 23,
        "title": "Festival Capital 2023 movil (registro y edición)",
        "category": "general",
        "videoSrc": "/assets/videos/Festival Capital 2023 movil (registro y edición).webm",
        "poster": "",
        "column": 2
    },
    {
        "id": 24,
        "title": "Fiesta Hipico (registro y edición)",
        "category": "general",
        "videoSrc": "/assets/videos/Fiesta Hipico (registro y edición).webm",
        "poster": "/assets/videos/Fiesta Hipico (registro y edición).webp",
        "column": 3
    },
    {
        "id": 25,
        "title": "Greta Gerwig perfil (Edición)",
        "category": "general",
        "videoSrc": "/assets/videos/Greta Gerwig perfil (Edición).mp4",
        "poster": "/assets/videos/Greta Gerwig perfil (Edición).webp",
        "column": 0
    },
    {
        "id": 26,
        "title": "H. P. Lovecraft (Edición) ",
        "category": "general",
        "videoSrc": "/assets/videos/H. P. Lovecraft (Edición) .webm",
        "poster": "/assets/videos/H. P. Lovecraft (Edición) .webp",
        "column": 1
    },
    {
        "id": 27,
        "title": "Institucional Fedes Consultora",
        "category": "general",
        "videoSrc": "/assets/videos/Institucional Fedes Consultora.webm",
        "poster": "/assets/videos/Institucional Fedes Consultora.webp",
        "column": 2
    },
    {
        "id": 28,
        "title": "Kieran Culkin (Guion y edición)",
        "category": "general",
        "videoSrc": "/assets/videos/Kieran Culkin (Guion y edición).webm",
        "poster": "/assets/videos/Kieran Culkin (Guion y edición).webp",
        "column": 3
    },
    {
        "id": 29,
        "title": "Kirsten Dunst (Edición)",
        "category": "general",
        "videoSrc": "/assets/videos/Kirsten Dunst (Edición).webm",
        "poster": "/assets/videos/Kirsten Dunst (Edición).webp",
        "column": 0
    },
    {
        "id": 30,
        "title": "Lollapalooza 2023 (edición y registro)",
        "category": "general",
        "videoSrc": "/assets/videos/Lollapalooza 2023 (edición y registro).webm",
        "poster": "/assets/videos/Lollapalooza 2023 (edición y registro).webp",
        "column": 1,
        "mentions": [
            {
                "name": "Marina Garrone",
                "occupation": "Redactora Creativa",
                "link": "https://signodefueg0.com"
            }
        ]
    },
    {
        "id": 31,
        "title": "Mac Demarco (Edición)",
        "category": "general",
        "videoSrc": "/assets/videos/Mac Demarco (Edición).webm",
        "poster": "/assets/videos/Mac Demarco (Edición).webp",
        "column": 2
    },
    {
        "id": 32,
        "title": "Michael Cera (Edición y guion propio)",
        "category": "general",
        "videoSrc": "/assets/videos/Michael Cera (Edición y guion propio).webm",
        "poster": "/assets/videos/Michael Cera (Edición y guion propio).webp",
        "column": 3
    },
    {
        "id": 34,
        "title": "Móvil en calle - tema alquileres (filmmaker y edición)",
        "category": "general",
        "videoSrc": "/assets/videos/Móvil en calle - tema alquileres (filmmaker y edición).webm",
        "poster": "/assets/videos/Móvil en calle - tema alquileres (filmmaker y edición).webp",
        "column": 0
    },
    {
        "id": 33,
        "title": "Móvil en calle - tema Barbie (filmmaker y edición)",
        "category": "general",
        "videoSrc": "/assets/videos/Móvil en calle - tema Barbie (filmmaker y edición).webm",
        "poster": "/assets/videos/Móvil en calle - tema Barbie (filmmaker y edición).webp",
        "column": 1
    },
    {
        "id": 35,
        "title": "Olivia Rodrigo (Edición)",
        "category": "general",
        "videoSrc": "/assets/videos/Olivia Rodrigo (Edición).mp4",
        "poster": "/assets/videos/Olivia Rodrigo (Edición).webp",
        "column": 2
    },
    {
        "id": 36,
        "title": "Paris Hilton (Edición)",
        "category": "general",
        "videoSrc": "/assets/videos/Paris Hilton (Edición).webm",
        "poster": "/assets/videos/Paris Hilton (Edición).webp",
        "column": 3
    },
    {
        "id": 37,
        "title": "Plastilina Banda",
        "category": "general",
        "videoSrc": "/assets/videos/Plastilina Banda.webm",
        "poster": "/assets/videos/Plastilina Banda.webp",
        "column": 0
    },
    {
        "id": 38,
        "title": "Promo animada TuCan tienda de mascotas",
        "category": "general",
        "videoSrc": "/assets/videos/Promo animada TuCan tienda de mascotas.mp4",
        "poster": "/assets/videos/Promo animada TuCan tienda de mascotas.webp",
        "column": 1
    },
    {
        "id": 39,
        "title": "Rebranding-Blick-News-2023",
        "category": "general",
        "videoSrc": "/assets/videos/Rebranding-Blick-News-2023.webm",
        "poster": "/assets/videos/Rebranding-Blick-News-2023.webp",
        "column": 2
    },
    {
        "id": 41,
        "title": "Recorrido de propiedad en venta - Asesora inmobiliaria (Registro y edición)",
        "category": "general",
        "videoSrc": "/assets/videos/Recorrido de propiedad en venta - Asesora inmobiliaria (Registro y edición).mp4",
        "poster": "/assets/videos/Recorrido de propiedad en venta - Asesora inmobiliaria (Registro y edición).webp",
        "column": 3
    },
    {
        "id": 40,
        "title": "Recorrido de propiedad en venta (Registro y edición)",
        "category": "general",
        "videoSrc": "/assets/videos/Recorrido de propiedad en venta (Registro y edición).mp4",
        "poster": "/assets/videos/Recorrido de propiedad en venta (Registro y edición).webp",
        "column": 0
    },
    {
        "id": 42,
        "title": "Recorrido de propiedad en venta 2 (Registro y edición)",
        "category": "general",
        "videoSrc": "/assets/videos/Recorrido de propiedad en venta 2 (Registro y edición).mp4",
        "poster": "/assets/videos/Recorrido de propiedad en venta 2 (Registro y edición).webp",
        "column": 1
    },
    {
        "id": 43,
        "title": "Reel 2 Avance obra Mininiterio de infrastructura (edición)",
        "category": "general",
        "videoSrc": "/assets/videos/Reel 2 Avance obra Mininiterio de infrastructura (edición).mp4",
        "poster": "/assets/videos/Reel 2 Avance obra Mininiterio de infrastructura (edición).webp",
        "column": 2
    },
    {
        "id": 53,
        "title": "Reel app MikVet (guión y edición)",
        "category": "general",
        "videoSrc": "/assets/videos/Reel app MikVet (guión y edición).webm",
        "poster": "/assets/videos/Reel app MikVet (guión y edición).webp",
        "column": 3
    },
    {
        "id": 54,
        "title": "Reel app MikVet 2 (guión y edición)",
        "category": "general",
        "videoSrc": "/assets/videos/Reel app MikVet 2 (guión y edición).webm",
        "poster": "/assets/videos/Reel app MikVet 2 (guión y edición).webp",
        "column": 0
    },
    {
        "id": 55,
        "title": "Reel app MikVet Paso a paso (guión y edición)",
        "category": "general",
        "videoSrc": "/assets/videos/Reel app MikVet Paso a paso (guión y edición).webm",
        "poster": "/assets/videos/Reel app MikVet Paso a paso (guión y edición).webp",
        "column": 1
    },
    {
        "id": 44,
        "title": "Reel Avance obra Mininiterio de infrastructura (edición)",
        "category": "general",
        "videoSrc": "/assets/videos/Reel Avance obra Mininiterio de infrastructura (edición).mp4",
        "poster": "/assets/videos/Reel Avance obra Mininiterio de infrastructura (edición).webp",
        "column": 2
    },
    {
        "id": 45,
        "title": "Reel Backstage MIKVET",
        "category": "general",
        "videoSrc": "/assets/videos/Reel Backstage MIKVET.webm",
        "poster": "/assets/videos/Reel Backstage MIKVET.webp",
        "column": 3
    },
    {
        "id": 46,
        "title": "Reel Bjork(Edición)",
        "category": "general",
        "videoSrc": "/assets/videos/Reel Bjork(Edición).webm",
        "poster": "/assets/videos/Reel Bjork(Edición).webp",
        "column": 0
    },
    {
        "id": 56,
        "title": "Reel campaña MikVet",
        "category": "general",
        "videoSrc": "/assets/videos/Reel campaña MikVet.webm",
        "poster": "/assets/videos/Reel campaña MikVet.webp",
        "column": 1
    },
    {
        "id": 47,
        "title": "Reel Campaña sorteo MikVet",
        "category": "general",
        "videoSrc": "/assets/videos/Reel Campaña sorteo MikVet.webm",
        "poster": "/assets/videos/Reel Campaña sorteo MikVet.webp",
        "column": 2
    },
    {
        "id": 57,
        "title": "Reel de información de Desarrollo inmobiliario (Edición)",
        "category": "general",
        "videoSrc": "/assets/videos/Reel de información de Desarrollo inmobiliario (Edición).mp4",
        "poster": "/assets/videos/Reel de información de Desarrollo inmobiliario (Edición).webp",
        "column": 3
    },
    {
        "id": 58,
        "title": "Reel de posicionamiento Asesoria inmobiliaria (registro y edición)",
        "category": "general",
        "videoSrc": "/assets/videos/Reel de posicionamiento Asesoria inmobiliaria (registro y edición).mp4",
        "poster": "/assets/videos/Reel de posicionamiento Asesoria inmobiliaria (registro y edición).webp",
        "column": 0
    },
    {
        "id": 59,
        "title": "Reel de posicionamiento KronenVet (guion y edición)",
        "category": "general",
        "videoSrc": "/assets/videos/Reel de posicionamiento KronenVet (guion y edición).mp4",
        "poster": "/assets/videos/Reel de posicionamiento KronenVet (guion y edición).webp",
        "column": 1
    },
    {
        "id": 60,
        "title": "Reel de producto - Livra alimento para mascotas",
        "category": "general",
        "videoSrc": "/assets/videos/Reel de producto - Livra alimento para mascotas.webm",
        "poster": "",
        "column": 2
    },
    {
        "id": 61,
        "title": "Reel ganador Campaña MikVet",
        "category": "general",
        "videoSrc": "/assets/videos/Reel ganador Campaña MikVet.webm",
        "poster": "/assets/videos/Reel ganador Campaña MikVet.webp",
        "column": 3
    },
    {
        "id": 49,
        "title": "Reel Livra aliemento (posicionamineto)",
        "category": "general",
        "videoSrc": "/assets/videos/Reel Livra aliemento (posicionamineto).webm",
        "poster": "/assets/videos/Reel Livra aliemento (posicionamineto).webp",
        "column": 0
    },
    {
        "id": 50,
        "title": "Reel Livra alimento - ingredientes",
        "category": "general",
        "videoSrc": "/assets/videos/Reel Livra alimento - ingredientes.webm",
        "poster": "/assets/videos/Reel Livra alimento - ingredientes.webp",
        "column": 1
    },
    {
        "id": 48,
        "title": "Reel Livra Posicionamiento",
        "category": "general",
        "videoSrc": "/assets/videos/Reel Livra Posicionamiento.webm",
        "poster": "/assets/videos/Reel Livra Posicionamiento.webp",
        "column": 2
    },
    {
        "id": 51,
        "title": "Reel PARÁ DE SCROLLEAR ReadytoFly",
        "category": "general",
        "videoSrc": "/assets/videos/Reel PARÁ DE SCROLLEAR ReadytoFly.mp4",
        "poster": "/assets/videos/Reel PARÁ DE SCROLLEAR ReadytoFly.webp",
        "column": 3
    },
    {
        "id": 62,
        "title": "Reel posicionamiento - Inmobiliaria en Panamá",
        "category": "general",
        "videoSrc": "/assets/videos/Reel posicionamiento - Inmobiliaria en Panamá.mp4",
        "poster": "/assets/videos/Reel posicionamiento - Inmobiliaria en Panamá.webp",
        "column": 0
    },
    {
        "id": 52,
        "title": "Reel Skay Gym",
        "category": "general",
        "videoSrc": "/assets/videos/Reel Skay Gym.webm",
        "poster": "/assets/videos/Reel Skay Gym.webp",
        "column": 1
    },
    {
        "id": 63,
        "title": "Registro de proceso",
        "category": "general",
        "videoSrc": "/assets/videos/Registro de proceso.webm",
        "poster": "/assets/videos/Registro de proceso.webp",
        "column": 2
    },
    {
        "id": 64,
        "title": "Reportaje periodistico DATO RANDOM CALLE NY",
        "category": "general",
        "videoSrc": "/assets/videos/Reportaje periodistico DATO RANDOM CALLE NY.webm",
        "poster": "/assets/videos/Reportaje periodistico DATO RANDOM CALLE NY.webp",
        "column": 3
    },
    {
        "id": 65,
        "title": "Rosalia (Guion y edición)",
        "category": "general",
        "videoSrc": "/assets/videos/Rosalia (Guion y edición).webm",
        "poster": "/assets/videos/Rosalia (Guion y edición).webp",
        "column": 0
    },
    {
        "id": 66,
        "title": "Spot KrönenVet _ MiKVet",
        "category": "general",
        "videoSrc": "/assets/videos/Spot KrönenVet _ MiKVet.webm",
        "poster": "/assets/videos/Spot KrönenVet _ MiKVet.webp",
        "column": 1
    },
    {
        "id": 67,
        "title": "TV GIRL (Guion y edición propia)",
        "category": "general",
        "videoSrc": "/assets/videos/TV GIRL (Guion y edición propia).webm",
        "poster": "/assets/videos/TV GIRL (Guion y edición propia).webp",
        "column": 2
    },
    {
        "id": 68,
        "title": "Twenty One Pilots (Guion y edición)",
        "category": "general",
        "videoSrc": "/assets/videos/Twenty One Pilots (Guion y edición).webm",
        "poster": "/assets/videos/Twenty One Pilots (Guion y edición).webp",
        "column": 3
    },
    {
        "id": 69,
        "title": "Xavier dolan (Guion y edición propia)",
        "category": "general",
        "videoSrc": "/assets/videos/Xavier dolan (Guion y edición propia).webm",
        "poster": "/assets/videos/Xavier dolan (Guion y edición propia).webp",
        "column": 0
    }
];